var _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import JSONAPISerializer from "@ember-data/serializer/json-api";
import { service } from "@ember/service";
import SemeiaSessionService from "core/services/session";
import { serializeToDateString } from "core/utils/time";
let _class = (_class2 = class _class2 extends JSONAPISerializer {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _defineProperty(this, "attrs", {
      uuid: {
        serialize: false
      },
      passwordChangedAt: {
        serialize: false
      }
    });
  }
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    delete json.data.attributes["uses-the-app"];
    delete json.data.attributes["access-word"];
    delete json.data.attributes["patient-consent"];
    delete json.data.attributes["clinical-study-id"];
    delete json.data.attributes["has-ongoing-rch-survey-procedure"];
    delete json.data.attributes["has-ongoing-crohn-survey-procedure"];
    const birthday = snapshot.attr("birthday");
    if (birthday) {
      json.data.attributes.birthday = serializeToDateString(birthday);
    }
    if (!snapshot.record.isNew) {
      // Patients don't have the rights to update the health-centre.
      if (this.session.patient && json.data.relationships) {
        delete json.data.relationships["health-centre"];
      }
    }
    return json;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };